import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import Hero from "./sections/Hero";
import PopularLabValues from "./sections/PopularLabValues";
import HowItWorks from "./sections/HowItWorks";
import GetUpdatesWhenNewLabExplanationsArePublished from "./sections/GetUpdatesWhenNewLabExplanationsArePublished";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <Hero />
      <PopularLabValues />
      <HowItWorks />
      <GetUpdatesWhenNewLabExplanationsArePublished />
      <Footer />
    </div>;
}